// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3mOse","cell":"ColumnAccessor_cell__1_pla","firstCellAccent":"ColumnAccessor_firstCellAccent__3gElh"};